"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var framer_motion_1 = require("framer-motion");
var react_1 = __importStar(require("react"));
// import Avatar from '../Avatar'
var apps_shared_1 = require("@l2p/apps-shared");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var barItems = ['frontBar'];
var Level = function (_a) {
    var image = _a.image;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("img", { src: image, alt: "level" })));
};
var Progress = function (_a) {
    var diffCount = _a.diffCount, prevProgress = _a.prevProgress, progressPercents = _a.progressPercents, level = _a.level, currentExp = _a.currentExp, totalExp = _a.totalExp, currentLevelData = _a.currentLevelData;
    var barAnimation = (0, framer_motion_1.useAnimation)();
    var barNumAnimation = (0, framer_motion_1.useAnimation)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var progressBarContinueAnimation = (0, react_1.useCallback)(function (persent) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, barAnimation.start(function (i) { return ({
                        width: "".concat(persent, "%"),
                        transition: {
                            delay: (i + 1) * 3,
                            duration: 2,
                        },
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [barAnimation]);
    var numberContinueAnimation = (0, react_1.useCallback)(function (persent) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, barNumAnimation.start({
                        width: "".concat(persent, "%"),
                        opacity: 1,
                        transition: {
                            delay: 3,
                            duration: 2,
                        },
                    })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, barNumAnimation.start({
                            opacity: 0,
                            transition: {
                                delay: 2,
                            },
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [barNumAnimation]);
    (0, react_1.useEffect)(function () {
        if (breakpoints.mobile) {
            progressBarContinueAnimation(progressPercents);
            numberContinueAnimation(progressPercents);
        }
        return function () {
            barAnimation.stop();
            barNumAnimation.stop();
        };
        //eslint-disable-next-line
    }, []);
    (0, react_1.useEffect)(function () {
        progressBarContinueAnimation(progressPercents);
        numberContinueAnimation(progressPercents);
    }, [numberContinueAnimation, progressBarContinueAnimation, progressPercents]);
    var barStart = (0, react_1.useMemo)(function () {
        var hiddenScale = prevProgress ? prevProgress : 0;
        return {
            width: "".concat(hiddenScale, "%"),
        };
    }, [prevProgress]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(Level, { image: currentLevelData.images.small }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.currentExp }, currentExp),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.progressBarWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.colorBarsContainer }, barItems.map(function (el, i) {
                return (react_1.default.createElement(framer_motion_1.motion.div, { className: styles_module_scss_1.default.progressBar, key: el, custom: i, animate: barAnimation, initial: barStart }));
            }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.totalExp }, totalExp),
        react_1.default.createElement(Level, { image: currentLevelData.images.next })));
};
exports.default = react_1.default.memo(Progress);
